import React from 'react';
import { BrowserRouter as Route, Link } from 'react-router-dom';

function Footer() {
  return (
    <div className="footer-03">
      <div className="container">
        <div className="footer-03__wrapper">
          <div className="footer-03__social">
            <ul className="footer-03__social_list">
              <li className="footer-03__social_item"><a className="footer-03__social_link"
                href="#" rel="noopener noreferrer"><img className="footer-03__social_icon"
                  src="img/icons/social/black/instagram.svg" alt="insta" /><span className="footer-03__social_text">Instagram</span></a>
              </li>
              <li className="footer-03__social_item"><a className="footer-03__social_link"
                href="#" rel="noopener noreferrer"><img className="footer-03__social_icon"
                  src="img/icons/social/black/twitter.svg" alt="twitter" /><span className="footer-03__social_text">Twitter</span></a>
              </li>
              <span className="footer-03__social_item"><a className="footer-03__social_link"
                href="#" rel="noopener noreferrer"><img className="footer-03__social_icon"
                  src="img/icons/social/black/facebook.svg" alt="fb" /><span className="footer-03__social_text">Facebook</span></a>
              </span>
            </ul>
          </div>
          <div className="footer-03__pages">
            <ul className="footer-03__pages_list">
              <li className="footer-03__pages_item"><Link className="footer-03__pages_link" to="/Affiliate">Affiliate</Link></li>
              <li className="footer-03__pages_item"><Link className="footer-03__pages_link" to="/Terms">Terms</Link>
              </li>
              <li className="footer-03__pages_item"><Link className="footer-03__pages_link" to="/Privacy">Privacy</Link>
              </li>
              <li className="footer-03__pages_item"><a className="footer-03__pages_link" href="mailto:team@parcelstoday.com"
                target="_blank" rel="noopener noreferrer">Email</a></li>
            </ul>
          </div>
          <div className="footer-03__text_box">
            <div className="footer-03__text">&copy; 2019&nbsp;<a className="footer-03__link" href="index.html">Parcels Today</a>.</div>
            <div className="footer-03__text">All rights reserved.</div>
          </div><img className="footer-03__grid" src="img/other/grid.png" alt="grid" />
        </div>
      </div>
    </div>

  )
}

export default Footer;